export const visit = (vm, at) => {
at({ "en": { "conversationsVisitorUIAvailability": { "sameDay": "We'll return today at {{time}}", "nextDay": "We'll return tomorrow at {{time}}", "nextWeek": "We'll return {{dayOfWeek}} at {{time}}" } } });
};